module.exports = __webpack_public_path__ + "img/arrow_forward_ios_FILL0_wght400_GRAD0_opsz24.6c686fe8.svg";